import React from "react";
import Introduction from "./Partials/Introduction";
import {stripHttps} from "./Support/Helper";
import {DefaultLoader} from "./Partials/LoadingIndicator";

export default class Loader extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className='scanner-loader'>
                <div className='container mx-auto px-3 text-center'>
                    <div className='container-inner'>
                        <div className='py-12 flex justify-center'>
                            <div className='max-w-2xl'>
                                <div className='text-center'>
                                    <Introduction
                                        prefix={stripHttps(this.props.url)}
                                        headline={"Suche nach Google Fonts läuft&nbsp;..."}
                                        suffix={"Die Ergebnisse liegen in Kürze vor."}
                                    />
                                </div>
                                <div
                                    className={`md:flex-row md:mt-12 flex flex-col space-y-6 space-x-6 justify-center items-center mt-6`}>
                                    <div aria-label='Loader Gesamtfortschritt'
                                         className='w-24 md:w-40 flex-shrink-0'>
                                        <DefaultLoader duration={25}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
